// src/components/three/LevelUpCelebration.tsx
// レベルアップ時の署名的演出（稀イベント）。金の3Dエンブレム＋金の粒子＋カウント表示。
// reduced-motion / 低性能では静止フォールバック（HeroEmblem内で処理）＋confettiは自動抑制。
import React, { useEffect } from 'react';
import { Dialog, Box, Typography, Button } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import HeroEmblem from './HeroEmblem';
import { celebrateBig } from '@/components/motion';

interface Props {
    open: boolean;
    level: number;
    onClose: () => void;
    message?: string;
}

const LevelUpCelebration: React.FC<Props> = ({ open, level, onClose, message }) => {
    useEffect(() => {
        if (open) {
            // ダイアログ表示に合わせて金の粒子を舞わせる
            const t = setTimeout(() => celebrateBig(), 180);
            return () => clearTimeout(t);
        }
    }, [open]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    textAlign: 'center',
                    p: 3,
                    borderRadius: 4,
                    border: '1px solid rgba(228,185,91,0.3)',
                    background:
                        'radial-gradient(120% 100% at 50% 0%, #1C222B 0%, #0E1116 70%)',
                },
            }}
        >
            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <Typography
                            variant="overline"
                            sx={{ color: 'primary.main', letterSpacing: 3 }}
                        >
                            LEVEL UP
                        </Typography>
                        <HeroEmblem height={200} />
                        <Typography variant="h3" sx={{ mt: 1, color: 'text.primary' }}>
                            Lv.{level}
                        </Typography>
                        {message && (
                            <Typography
                                variant="body2"
                                sx={{ color: 'text.secondary', mt: 1 }}
                            >
                                {message}
                            </Typography>
                        )}
                        <Button
                            variant="contained"
                            onClick={onClose}
                            sx={{ mt: 3, minWidth: 140 }}
                        >
                            続ける
                        </Button>
                    </motion.div>
                )}
            </AnimatePresence>
        </Dialog>
    );
};

export default LevelUpCelebration;
